module.exports = __webpack_public_path__ + "img/accessory.9e7328df.png";